import * as React from 'react';

function SvgDarkModeFilled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" {...props}>
      <g fillRule="evenodd">
        <circle cx={10.5} cy={10.5} r={10.5} />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M13.396 11c0-3.019-1.832-5.584-4.394-6.566A6.427 6.427 0 0111.304 4C15.002 4 18 7.135 18 11c0 3.866-2.998 7-6.698 7A6.42 6.42 0 019 17.566c2.564-.98 4.396-3.545 4.396-6.566z"
        />
      </g>
    </svg>
  );
}

export default SvgDarkModeFilled;
